import { getDefaultConversationFilters } from '~/utils/conversation-filters';

interface QueryFiltersReducerProps {
  type: 'SET_QUERY_FILTERS' | 'GET_QUERY_FILTERS' | 'CLEAR_QUERY_FILTERS';
  payload: any;
}

// Try to get filters from URL on initial load (client only)
let filtersFromURL = {};
if (typeof window !== 'undefined') {
  const searchParams = new URLSearchParams(window.location.search);
  const filtersParam = searchParams.get('filters');

  if (filtersParam) {
    try {
      const decoded = decodeURIComponent(filtersParam);
      filtersFromURL = JSON.parse(decoded);
    } catch (err) {
      console.error('Failed to parse filters from URL:', err);
    }
  }
}

const originalState = { ...getDefaultConversationFilters(), ...filtersFromURL };

const queryFiltersReducer = (state = originalState, action: QueryFiltersReducerProps) => {
  switch (action.type) {
    case 'SET_QUERY_FILTERS':
      return { ...state, ...action.payload };
    case 'GET_QUERY_FILTERS':
      return state;
    case 'CLEAR_QUERY_FILTERS':
      return originalState;
    default:
      return state;
  }
};

export default queryFiltersReducer;
